import { FC, ReactNode } from "react";
import "./content-header.scss";
import verifiedImage from "../../../src/assets/images/verified-block.png";
import unverifiedImage from "../../../src/assets/images/unverified-block.png";

interface ContentHeaderProps {
  pageTitle: string;
  children?: ReactNode;
  isVerified?: boolean;
  isBlockDetails?: boolean;
}

const ContentHeader: FC<ContentHeaderProps> = ({
  children,
  pageTitle,
  isVerified,
  isBlockDetails,
}) => {
  return (
    <div className="contentHeader ">
      <div className="flex">
        <div className="flex">
          <div className="page-header d-flex">
            <b>{pageTitle}</b>
            {isBlockDetails && isVerified ? (
              <div>
                <img
                  src={verifiedImage}
                  alt="verified"
                  className="ms-4"
                  height={"50px"}
                  title="Verified"
                />
              </div>
            ) : null}
          </div>
        </div>

        {children ? (
          <div className="flex flex-auto justify-end filter">{children}</div>
        ) : null}
      </div>
    </div>
  );
};

export default ContentHeader;
